import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

// Firebase configuration - in a real app, these would be environment variables
const firebaseConfig = {
  apiKey: "AIzaSyCt6Klr7oOxx49ce4ul5YVwuj49kWBLnUc",
  authDomain: "focuskochi.firebaseapp.com",
  projectId: "focuskochi",
  storageBucket: "focuskochi.appspot.com",
  messagingSenderId: "1086615085747",
  appId: "1:1086615085747:web:606d2c6f7d0bb6639e86c6",
  databaseURL: "https://focuskochi-default-rtdb.asia-southeast1.firebasedatabase.app"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const realtimeDb = getDatabase(app);

export { app, db, auth, realtimeDb };
